import { render, staticRenderFns } from "./PostTermSaleQueue.vue?vue&type=template&id=bfef8b0c&scoped=true"
import script from "./PostTermSaleQueue.vue?vue&type=script&lang=js"
export * from "./PostTermSaleQueue.vue?vue&type=script&lang=js"
import style0 from "./PostTermSaleQueue.vue?vue&type=style&index=0&id=bfef8b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfef8b0c",
  null
  
)

export default component.exports